import React from 'react'
import moment from 'moment'
import InvisibleText from '@components/InvisibleText'
import { TEventResource } from './interface'

interface IPEventInfo {
  resource: TEventResource
}

const EventInfo: React.FC<IPEventInfo> = ({ resource }) => {
  return (
    <InvisibleText>
      <p>Id: {resource?.Id}</p>
      {resource?.IsUnAvailability ? (
        <>
          <p>Start Date: {resource?.StartDateTime}</p>
          <p>End Date: {resource?.EndDateTime}</p>
          <p>Keep Lessons: {`${resource?.KeepExistingLessons}`}</p>
        </>
      ) : (
        <>
          <p>Start Date: {resource?.StartDate}</p>
          <p>Start Time: {resource?.StartTime}</p>
          <p>End Time: {resource?.EndTime}</p>
          <p>Availability TimeZone: {resource?.TimeZone}</p>
          <p>Browser TimeZone: {moment.tz.guess()}</p>
        </>
      )}
    </InvisibleText>
  )
}

export default EventInfo
